module.exports = __webpack_public_path__ + "img/tela.4139e64b.png";